import React, { Fragment, useEffect, useState } from 'react'
import TimsheetSc from './Timesheet.sc'
import { useAuthContext } from '../../hooks'
import { getAllProjects } from '../../api/project/getProjects'
import { useForm } from 'react-hook-form'
import { insert_timesheet } from '../../api/Timesheet/create/insert_timesheet'
import { getOrgProjectDetails } from '../../api/project/getOrgProjectDetails'
import MyTimeSheet from './components/MyTimeSheet/MyTimeSheet'
import { getOrgUsersProjects } from '../../api/project/getOrgUserProjects'
const Timesheet = () => {
  const auth = useAuthContext()
  const [getProjects, SetProjects] = useState<any[]>([])
const [isFormOpen,setIsFormOpen] = useState(false);


  const fetchOrguserProjects = async () => {
    await getOrgUsersProjects(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
    )
      .then((e: any) => {
        SetProjects(e)
      })
      .catch((e) => console.log(e))
  }
  const [selectedDay, setSelectedDay] = useState('Monday')

  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' })
  useEffect(() => {
    setSelectedDay(today)
  }, [])

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

  const { register, handleSubmit, watch, setValue } = useForm()
  const [duration, setDuration] = useState('')

  const watchStartTime = watch('start_time')
  const watchEndTime = watch('end_time')
  const watchProjectId = watch('project')



  const [memberId, setMemberId] = useState<any>({})

  const fetchOrgProjectDetails = async () => {
    // if (!params?.viewProjectId) return;
    const res = await getOrgProjectDetails(
      auth?.userInfo?.orgs[0]?.id,
      watchProjectId,
    )
    const filterMemberId = await res?.[0]?.Members.filter((data: any) => {
      return data.org_user_id === (auth?.userInfo?.orgs_user_id[0]).toString()
    })
    setMemberId(filterMemberId)
    console.log('works')
  }


  useEffect(() => {
    fetchOrguserProjects()
    if (watchProjectId) {
      fetchOrgProjectDetails()
    }
  }, [watchProjectId])
  console.log(getProjects, 'get projects')
  const getNextWeekDates = () => {
    const today = new Date();
    const todayDayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const daysUntilNextFriday = (5 - todayDayOfWeek + 7) % 7;
    const nextFriday = new Date(today);
    nextFriday.setDate(today.getDate() + daysUntilNextFriday);

    // Start of next week (Monday after next Friday)
    const startOfNextWeek = new Date(nextFriday);
    startOfNextWeek.setDate(nextFriday.getDate() + 3); // Adding 3 days to get to Monday

    // End of next week (Friday)
    const endOfNextWeek = new Date(startOfNextWeek);
    endOfNextWeek.setDate(startOfNextWeek.getDate() + 4); // Adding 4 days to get to Friday

    return {
      startOfNextWeek: startOfNextWeek.toISOString().split("T")[0],
      endOfNextWeek: endOfNextWeek.toISOString().split("T")[0]
    };
  };
  const [weekDates, setWeekDates] = useState<any>({
    startOfNextWeek: "",
    endOfNextWeek: ""
  });

  useEffect(() => {
    if (new Date().getDay() === 4) {
      // 5 represents Friday
      const dates = getNextWeekDates();
      setWeekDates(dates);
    }
  }, []);
  const todayIsFriday = new Date().getDay() === 4;
  console.log(weekDates,todayIsFriday,"see")
  const handleSelectChange = (event:any) => {
    // Convert the selected value to a number and update the form state
    const value = Number(event.target.value);
    // Assuming you are using a form library like react-hook-form
    setValue('timesheet_type_id', value);
  }
  const onSubmit = async (e: any) => {
    const res = await insert_timesheet(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
      watchProjectId,
      {
        ...e,
      week_start_date:weekDates.startOfNextWeek,
      week_end_date:weekDates.endOfNextWeek,
      date:weekDates.startOfNextWeek
      },
    )
    console.log(res)
  }
  return (
    <TimsheetSc>
      <div>
        <h3>Enter time sheet</h3>
          {
isFormOpen ? 
        <div className="form_container">
<div>
            <form onSubmit={handleSubmit(onSubmit)} >
              <div  className="form_sub">

              <div className="form_group">
                <label>Project:</label>
                <select
                  {...register('project', {
                    required: {
                      value: true,
                      message: 'This is required',
                    },
                  })}
                >
                  {getProjects?.map((data: any,idx:any) => {
                    return (
                      <Fragment key={idx}>
                        <option value={data?.ProjectId}>
                          {data?.ProjectName}
                        </option>
                      </Fragment>
                    )
                  })}
                </select>
              </div>
              <div className="form_group">
                <label>Task Name:</label>
                <input type="text" {...register('task_name')} />
              </div>
              <div className="form_group">
                <label>Monday</label>
                <input type="number" min={0} {...register('monday_hours')} />
              </div>  
              <div className="form_group">
                <label>Tuesday</label>
                <input type="number" min={0} {...register('tuesday_hours')} />
              </div>  
              <div className="form_group">
                <label>Wednesday</label>
                <input type="number" min={0} {...register('wednesday_hours')} />
              </div>  
              <div className="form_group">
                <label>Thursday</label>
                <input type="number" min={0} {...register('thursday_hours')} />
              </div>  
              <div className="form_group">
                <label>Friday</label>
                <input type="number"  min={0} {...register('friday_hours')} />
              </div>  
           
              <div className="form_group">
                <label>Comments:</label>
                <input type="text" {...register('comment')} />
              </div>
              <div className="form_group">
                <label>Time Sheet Type:</label>
                <select {...register('timesheet_type_id')} onChange={handleSelectChange}>
                  <option>Select an option</option>
                  <option value={1}>Project</option>
                  <option value={2}>Learning</option>
                  <option value={3}>Discussion</option>
                  <option value={4}>Others</option>
                  <option value={5}>PTO</option>
                </select>
              </div>
              <div className="form_group_button">
                <button type="submit" className="submit-button">
                  Submit
                </button>
              </div>
              </div>

            </form>
          </div>
        </div>:null
          }
          
         <button onClick={()=>setIsFormOpen(!isFormOpen)}>Add more</button>
      </div>
      <div>
        <MyTimeSheet weekdata={weekDates} />
      </div>
    </TimsheetSc>
  )
}

export default Timesheet
